import React from "react";
import WheelchairIconWhite from "../../assets/ui/icon-wheelchair-white-16.svg?url";
import WheelchairIconBlack from "../../assets/ui/icon-wheelchair-16.svg?url";
import PropTypes from "prop-types";

const AccessibilityWrapper = ({ children, accessibilityProperty }) => {
  return (
    <div
      className={`icon ${accessibilityProperty?.fieldTaxonomyFrontendId}`}
      key={accessibilityProperty.name}
    >
      {children}
    </div>
  );
};

AccessibilityWrapper.propTypes = {
  children: PropTypes.node,
  accessibilityProperty: PropTypes.object,
};

const AccessibilityIcons = ({ content, color = "white" }) => {
  if (content) {
    return (
      <div className="accessibility-icons">
        {content.map((accessibilityProperty, i) => (
          <React.Fragment key={i}>
            {accessibilityProperty && accessibilityProperty?.fieldTaxonomyFrontendId &&
              <>
                {(() => {
                  switch (accessibilityProperty.fieldTaxonomyFrontendId) {
                    case "wheelchair": {
                      return (
                        <AccessibilityWrapper
                          accessibilityProperty={accessibilityProperty}
                        >
                          {color === "white" ? (
                            <img className="icon icon-16" src={WheelchairIconWhite} alt={"Wheelchair Icon"} />
                          ) : (
                            <img className="icon icon-16" src={WheelchairIconBlack} alt={"Wheelchair Icon"} />
                          )}
                        </AccessibilityWrapper>
                      );
                    }
                    default:
                      return false;
                  }
                })()}
              </>
            }
          </React.Fragment>
        ))}
      </div>
    );
  }
};

AccessibilityIcons.propTypes = {
  content: PropTypes.array,
};

export default AccessibilityIcons;
